import { loadCatalog } from "./catalog";

export const isAntiGaspiActive = (product) => {
  if (!product || !product.antiGaspiDiscount || Number(product.antiGaspiDiscount) <= 0) {
    return false;
  }
  if (product.antiGaspiExpiresAt) {
    const expiry = new Date(`${product.antiGaspiExpiresAt}T00:00:00`);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (expiry < today) return false;
  }
  return true;
};

export const getAntiGaspiPrice = (product) => {
  if (!isAntiGaspiActive(product)) return null;
  const price = Number(product.price || 0);
  const discount = Number(product.antiGaspiDiscount || 0);
  return Math.round(price * (1 - discount / 100) * 100) / 100;
};

export const getEffectiveUnitPrice = (product) => {
  const reduced = getAntiGaspiPrice(product);
  return reduced !== null ? reduced : Number(product.price || 0);
};

export const formatEur = (value) => `${Number(value || 0).toFixed(2).replace(".", ",")} EUR`;

export const loadAntiGaspiProducts = async () => {
  const catalog = await loadCatalog();
  return catalog
    .filter((p) => isAntiGaspiActive(p))
    .map((p) => ({
      ...p,
      originalPriceLabel: formatEur(p.price),
      antiGaspiPrice: getAntiGaspiPrice(p),
      antiGaspiPriceLabel: formatEur(getAntiGaspiPrice(p)),
      image: p.imageUrl || "https://almoune.fr/img/p/0.jpg",
    }))
    .sort((a, b) => (b.antiGaspiDiscount || 0) - (a.antiGaspiDiscount || 0));
};
